import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    private router = inject(Router);
    private msalService = inject(MsalService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    const accounts = this.msalService.instance.getAllAccounts();

                    if (accounts.length > 0) {
                        void this.router.navigate(['/auth/unauthorized']);
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
